import { render, staticRenderFns } from "./RecoveryConfirm.vue?vue&type=template&id=5874ca3e&scoped=true&"
import script from "./RecoveryConfirm.vue?vue&type=script&lang=js&"
export * from "./RecoveryConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryConfirm.vue?vue&type=style&index=0&id=5874ca3e&lang=scss&scoped=true&"
import style1 from "./RecoveryConfirm.vue?vue&type=style&index=1&id=5874ca3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5874ca3e",
  null
  
)

export default component.exports